<template>
  <div style="width: 100%">
    <el-table :data="dataList" border style="width: 100%">
      <el-table-column
        type="index"
        label="行号"
        header-align="center"
        align="center"
        width="50"
      ></el-table-column>
      <el-table-column
        prop="agreementCode"
        label="合同编号"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="storageName"
        label="仓库名称"
        header-align="center"
        align="center"
        width="200"
      ></el-table-column>
      <el-table-column
        v-if="productType === '产品'"
        prop="code"
        label="品番号"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="品名"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="color"
        label="颜色"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="size"
        label="规格"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="attr1"
        label="幅宽"
        header-align="center"
        align="center"
        v-if="productType === '原料'"
      ></el-table-column>
      <el-table-column
        prop="attr2"
        label="克重"
        header-align="center"
        align="center"
        v-if="productType === '原料'"
      ></el-table-column>
      <el-table-column
        prop="attr3"
        label="裁剪尺寸"
        header-align="center"
        align="center"
        v-if="productType === '产品'"
      ></el-table-column>
      <el-table-column label="当前数量" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.count > 0">{{
            scope.row.count
          }}</el-tag>
          <el-tag type="danger" v-if="scope.row.count <= 0">{{
            scope.row.count
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="B品数量"
        header-align="center"
        align="center"
        v-if="hasCountB"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.countB > 0">{{
            scope.row.countB
          }}</el-tag>
          <el-tag type="danger" v-if="scope.row.countB <= 0">{{
            scope.row.countB
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="实际数量"
        header-align="center"
        align="center"
        v-if="hasCountB"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.realCount > 0">{{
            scope.row.realCount
          }}</el-tag>
          <el-tag type="danger" v-if="scope.row.realCount <= 0">{{
            scope.row.realCount
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="查看明细" header-align="center" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-search"
            @click="showDetailDialog(scope.row)"
            size="mini"
          >
            查看明细
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>
    <DetailDialog ref="detailDialog"></DetailDialog>
  </div>
</template>

<script>
import DetailDialog from "@/views/modules/store/common/detail-dialog.vue";
import mixinViewModule from "@/mixins/view-module";
export default {
  name: "order-box",
  mixins: [mixinViewModule],
  components: { DetailDialog },
  props: {
    agreementId: {
      type: String,
      default: "",
    },
    productType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      hasCountB: window.SITE_CONFIG["hasCountB"],
      mixinViewModuleOptions: {
        getDataListURL: "/trade/factorystore/page",
        getDataListIsPage: true,
        activatedIsNeed: false,
      },
      dataForm: {
        agreementId: "",
        productType: "",
      },
    };
  },
  watch: {
    agreementId: {
      handler: function(newVal) {
        this.dataForm.agreementId = newVal;
        this.refresh();
      },
      immediate: true,
    },
    productType: {
      handler: function(newVal) {
        this.dataForm.productType = newVal;
        this.refresh();
      },
      immediate: true,
    },
  },
  methods: {
    beforeTableBinding(dataList) {
      dataList.forEach((item) => {
        item.realCount = item.count - item.countB;
      });
    },
    showDetailDialog(row) {
      this.$refs.detailDialog.dataForm.storageId = row.storageId;
      this.$refs.detailDialog.dataForm.agreementId = row.agreementId;
      this.$refs.detailDialog.dataForm.agreementCode = row.agreementCode;
      this.$refs.detailDialog.dataForm.productId = row.productId;
      this.$refs.detailDialog.init();
    },
    refresh() {
      if (this.dataForm.productType && this.dataForm.agreementId) {
        this.getDataList();
      } else {
        this.dataList = [];
      }
    },
  },
};
</script>
